import { IndexDecoder } from "@mechination/indexenc";
import { db, unmarshallFile } from "../db";
import { createContext, ReactNode, useContext } from "react";
import { useLiveQuery } from "dexie-react-hooks";

export type SearchIndex = Map<string, Map<number, number>>;

export async function readSearchIndex(data: Uint8Array | undefined) {
  console.log("Loading offline search index");
  const newIndex: SearchIndex = new Map();

  if (data) {
    const decoder = new IndexDecoder();
    const reader = new Response(data).body!.getReader();
    // const tokensToDelete = new Set<string>((await db.search_tokens.toCollection().keys()) as string[]);
    let currentToken: string | undefined = undefined;
    let currentScores: Map<number, number> = new Map();

    while (true) {
      const { value, done } = await reader.read();
      if (value) {
        const items = decoder.parse(value);
        for (let item of items) {
          // When the token changes, switch map that we are writing to.
          if (item.token !== currentToken) {
            if (currentToken) {
              newIndex.set(currentToken, currentScores);
            }
            currentToken = item.token;
            currentScores = new Map<number, number>();
          }
          currentScores!.set(item.doc, item.score);
        }
      }
      if (done) {
        break;
      }
    }
    // Write the final one
    if (currentScores.size > 0) {
      newIndex.set(currentToken!, currentScores);
    }
  } else {
    console.log("No Search index has been downloaded");
  }
  console.log("Search index has size", Object.keys(newIndex).length);
  return newIndex;
}

export const SearchIndexContext = createContext<SearchIndex>(new Map());

export function useSearchIndex() {
  return useContext(SearchIndexContext);
}

const initialIndex = new Map();

export function SearchIndexProvider(props: { children: ReactNode }) {
  const searchIndex = useLiveQuery(
    async () => await readSearchIndex(await unmarshallFile(await db.files.get("meta/index.bin"))),
    [],
    initialIndex
  );
  return <SearchIndexContext.Provider value={searchIndex}>{props.children}</SearchIndexContext.Provider>;
}
